"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
function Toaster(props) {
    return (React.createElement("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24" }, props),
        React.createElement("path", { d: "M11.403 3c2.105.01 3.525.1 4.572.37.555.142 1.032.335 1.421.704.39.37.604.939.604 1.426 0 1.047-.526 1.618-1 1.984V9c2.197 0 4 1.803 4 4v1h1c.6 0 1 .4 1 1v1h-2v5H1v-8c0-2.197 1.803-4 4-4V7.543c-.08-.055-.09-.028-.17-.1C4.416 7.071 4 6.378 4 5.5c0-.494.197-1.075.594-1.459.396-.384.887-.577 1.445-.713C7.156 3.057 8.68 3 11 3zM17 11H5c-1.117 0-2 .883-2 2v6h16v-6c0-1.117-.883-2-2-2zm-5.648-5.999h-.705c-2.079.009-3.44.101-4.135.27-.356.087-.5.187-.518.202.003.004.006-.004.006.027 0 .322.084.38.17.457.086.077.117.086.117.086L7 6.256V9h8V6.322l.629-.25s.342-.097.361-.556c-.03-.025-.165-.12-.513-.21C14.738 5.118 13.27 5 11 5zM10 6a1 1 0 1 0 0 2 1 1 0 0 0 0-2zm2.5 1a.5.5 0 1 0 0 1 .5.5 0 0 0 0-1zm3.5 8a1 1 0 1 0 0 2 1 1 0 0 0 0-2z", fill: props.color || "#000", fillRule: "nonzero" })));
}
exports.default = Toaster;
